"use strict";
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Radio User Experience Engine API HM V2
 * Web-facing endpoints which are consumed and piped through to  Coordinator API.  Also handles initial determination of Domain and Application based on URI.
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiFetchParamCreator = exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = void 0;
const url = __importStar(require("url"));
const portableFetch = __importStar(require("portable-fetch"));
const BASE_PATH = "https://virtserver.swaggerhub.com/tugboat-holdings9/radioV2/0.0.1".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = portableFetch) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
exports.RequiredError = RequiredError;
/**
 * DefaultApi - fetch parameter creator
 * @export
 */
const DefaultApiFetchParamCreator = function (configuration) {
    return {
        /**
         * Web facing endpoint which receives all API calls and passes through to Coordinator for processing.
         * @summary Complete Step/Action for the current User and tell me the next Flow and Step
         * @param {CompleteRequest} body
         * @param {string} domain
         * @param {string} version
         * @param {string} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete(body, domain, version, app, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling complete.');
            }
            // verify required parameter 'domain' is not null or undefined
            if (domain === null || domain === undefined) {
                throw new RequiredError('domain', 'Required parameter domain was null or undefined when calling complete.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling complete.');
            }
            // verify required parameter 'app' is not null or undefined
            if (app === null || app === undefined) {
                throw new RequiredError('app', 'Required parameter app was null or undefined when calling complete.');
            }
            const localVarPath = `/{domain}/{version}/{app}/complete`
                .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"app"}}`, encodeURIComponent(String(app)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-KEY"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CompleteRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Web facing endpoint which receives all API calls and passes through to Coordinator for processing.
         * @summary Complete Step/Action for the current User and tell me the next Flow and Step
         * @param {ContinueRequest} body
         * @param {string} domain
         * @param {string} version
         * @param {string} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueApp(body, domain, version, app, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling continueApp.');
            }
            // verify required parameter 'domain' is not null or undefined
            if (domain === null || domain === undefined) {
                throw new RequiredError('domain', 'Required parameter domain was null or undefined when calling continueApp.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling continueApp.');
            }
            // verify required parameter 'app' is not null or undefined
            if (app === null || app === undefined) {
                throw new RequiredError('app', 'Required parameter app was null or undefined when calling continueApp.');
            }
            const localVarPath = `/{domain}/{version}/{app}/continue`
                .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"app"}}`, encodeURIComponent(String(app)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-KEY"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ContinueRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new profile for an App
         * @param {string} domain
         * @param {CreateRequest} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile(domain, body, options = {}) {
            // verify required parameter 'domain' is not null or undefined
            if (domain === null || domain === undefined) {
                throw new RequiredError('domain', 'Required parameter domain was null or undefined when calling createProfile.');
            }
            const localVarPath = `/{domain}/create`
                .replace(`{${"domain"}}`, encodeURIComponent(String(domain)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-KEY"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("CreateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initialize front end application given its host name and return analytics keys, theming information and Domain and App
         * @summary Initialize front end application given its host/domain
         * @param {InitializeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialize(body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling initialize.');
            }
            const localVarPath = `/initialize`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-KEY"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("InitializeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} profileUuid
         * @param {string} profileKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotator(profileUuid, profileKey, options = {}) {
            // verify required parameter 'profileUuid' is not null or undefined
            if (profileUuid === null || profileUuid === undefined) {
                throw new RequiredError('profileUuid', 'Required parameter profileUuid was null or undefined when calling rotator.');
            }
            // verify required parameter 'profileKey' is not null or undefined
            if (profileKey === null || profileKey === undefined) {
                throw new RequiredError('profileKey', 'Required parameter profileKey was null or undefined when calling rotator.');
            }
            const localVarPath = `/yourcase/rotator/rotate/{profileUuid}/{profileKey}`
                .replace(`{${"profileUuid"}}`, encodeURIComponent(String(profileUuid)))
                .replace(`{${"profileKey"}}`, encodeURIComponent(String(profileKey)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starting will call out to Coordinator API to create a user profile and return that and the Flow/Step. Then We will populate all the Flow/Step data needed for the Radio SDK to render the Step/Components/Responses.
         * @summary Start process with given referral and tags and tell me first flow/step.
         * @param {StartRequest} body
         * @param {string} domain
         * @param {string} version
         * @param {string} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        start(body, domain, version, app, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling start.');
            }
            // verify required parameter 'domain' is not null or undefined
            if (domain === null || domain === undefined) {
                throw new RequiredError('domain', 'Required parameter domain was null or undefined when calling start.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version', 'Required parameter version was null or undefined when calling start.');
            }
            // verify required parameter 'app' is not null or undefined
            if (app === null || app === undefined) {
                throw new RequiredError('app', 'Required parameter app was null or undefined when calling start.');
            }
            const localVarPath = `/{domain}/{version}/{app}/start`
                .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"app"}}`, encodeURIComponent(String(app)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-KEY"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("StartRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiFetchParamCreator = DefaultApiFetchParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    return {
        /**
         * Web facing endpoint which receives all API calls and passes through to Coordinator for processing.
         * @summary Complete Step/Action for the current User and tell me the next Flow and Step
         * @param {CompleteRequest} body
         * @param {string} domain
         * @param {string} version
         * @param {string} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete(body, domain, version, app, options) {
            const localVarFetchArgs = exports.DefaultApiFetchParamCreator(configuration).complete(body, domain, version, app, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Web facing endpoint which receives all API calls and passes through to Coordinator for processing.
         * @summary Complete Step/Action for the current User and tell me the next Flow and Step
         * @param {ContinueRequest} body
         * @param {string} domain
         * @param {string} version
         * @param {string} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueApp(body, domain, version, app, options) {
            const localVarFetchArgs = exports.DefaultApiFetchParamCreator(configuration).continueApp(body, domain, version, app, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Create a new profile for an App
         * @param {string} domain
         * @param {CreateRequest} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile(domain, body, options) {
            const localVarFetchArgs = exports.DefaultApiFetchParamCreator(configuration).createProfile(domain, body, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Initialize front end application given its host name and return analytics keys, theming information and Domain and App
         * @summary Initialize front end application given its host/domain
         * @param {InitializeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialize(body, options) {
            const localVarFetchArgs = exports.DefaultApiFetchParamCreator(configuration).initialize(body, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} profileUuid
         * @param {string} profileKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotator(profileUuid, profileKey, options) {
            const localVarFetchArgs = exports.DefaultApiFetchParamCreator(configuration).rotator(profileUuid, profileKey, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Starting will call out to Coordinator API to create a user profile and return that and the Flow/Step. Then We will populate all the Flow/Step data needed for the Radio SDK to render the Step/Components/Responses.
         * @summary Start process with given referral and tags and tell me first flow/step.
         * @param {StartRequest} body
         * @param {string} domain
         * @param {string} version
         * @param {string} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        start(body, domain, version, app, options) {
            const localVarFetchArgs = exports.DefaultApiFetchParamCreator(configuration).start(body, domain, version, app, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         * Web facing endpoint which receives all API calls and passes through to Coordinator for processing.
         * @summary Complete Step/Action for the current User and tell me the next Flow and Step
         * @param {CompleteRequest} body
         * @param {string} domain
         * @param {string} version
         * @param {string} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete(body, domain, version, app, options) {
            return exports.DefaultApiFp(configuration).complete(body, domain, version, app, options)(fetch, basePath);
        },
        /**
         * Web facing endpoint which receives all API calls and passes through to Coordinator for processing.
         * @summary Complete Step/Action for the current User and tell me the next Flow and Step
         * @param {ContinueRequest} body
         * @param {string} domain
         * @param {string} version
         * @param {string} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueApp(body, domain, version, app, options) {
            return exports.DefaultApiFp(configuration).continueApp(body, domain, version, app, options)(fetch, basePath);
        },
        /**
         *
         * @summary Create a new profile for an App
         * @param {string} domain
         * @param {CreateRequest} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile(domain, body, options) {
            return exports.DefaultApiFp(configuration).createProfile(domain, body, options)(fetch, basePath);
        },
        /**
         * Initialize front end application given its host name and return analytics keys, theming information and Domain and App
         * @summary Initialize front end application given its host/domain
         * @param {InitializeRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialize(body, options) {
            return exports.DefaultApiFp(configuration).initialize(body, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} profileUuid
         * @param {string} profileKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotator(profileUuid, profileKey, options) {
            return exports.DefaultApiFp(configuration).rotator(profileUuid, profileKey, options)(fetch, basePath);
        },
        /**
         * Starting will call out to Coordinator API to create a user profile and return that and the Flow/Step. Then We will populate all the Flow/Step data needed for the Radio SDK to render the Step/Components/Responses.
         * @summary Start process with given referral and tags and tell me first flow/step.
         * @param {StartRequest} body
         * @param {string} domain
         * @param {string} version
         * @param {string} app
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        start(body, domain, version, app, options) {
            return exports.DefaultApiFp(configuration).start(body, domain, version, app, options)(fetch, basePath);
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends BaseAPI {
    /**
     * Web facing endpoint which receives all API calls and passes through to Coordinator for processing.
     * @summary Complete Step/Action for the current User and tell me the next Flow and Step
     * @param {CompleteRequest} body
     * @param {string} domain
     * @param {string} version
     * @param {string} app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    complete(body, domain, version, app, options) {
        return exports.DefaultApiFp(this.configuration).complete(body, domain, version, app, options)(this.fetch, this.basePath);
    }
    /**
     * Web facing endpoint which receives all API calls and passes through to Coordinator for processing.
     * @summary Complete Step/Action for the current User and tell me the next Flow and Step
     * @param {ContinueRequest} body
     * @param {string} domain
     * @param {string} version
     * @param {string} app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    continueApp(body, domain, version, app, options) {
        return exports.DefaultApiFp(this.configuration).continueApp(body, domain, version, app, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Create a new profile for an App
     * @param {string} domain
     * @param {CreateRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createProfile(domain, body, options) {
        return exports.DefaultApiFp(this.configuration).createProfile(domain, body, options)(this.fetch, this.basePath);
    }
    /**
     * Initialize front end application given its host name and return analytics keys, theming information and Domain and App
     * @summary Initialize front end application given its host/domain
     * @param {InitializeRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    initialize(body, options) {
        return exports.DefaultApiFp(this.configuration).initialize(body, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} profileUuid
     * @param {string} profileKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    rotator(profileUuid, profileKey, options) {
        return exports.DefaultApiFp(this.configuration).rotator(profileUuid, profileKey, options)(this.fetch, this.basePath);
    }
    /**
     * Starting will call out to Coordinator API to create a user profile and return that and the Flow/Step. Then We will populate all the Flow/Step data needed for the Radio SDK to render the Step/Components/Responses.
     * @summary Start process with given referral and tags and tell me first flow/step.
     * @param {StartRequest} body
     * @param {string} domain
     * @param {string} version
     * @param {string} app
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    start(body, domain, version, app, options) {
        return exports.DefaultApiFp(this.configuration).start(body, domain, version, app, options)(this.fetch, this.basePath);
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=api.js.map